// MTReturnsActionsCell - per-row Actions column for the Returns grid.
// AC4 (PNW-1765): View (open generated return output) + Refresh (regenerate).
// The Download action was moved OUT of this cell into the form-view header
// (parity with the India Returns flow) - clicking View now opens the return
// form/detail view instead of enqueuing a download.
import RefreshIcon from '@mui/icons-material/Refresh'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'
import { Box, CircularProgress, IconButton, Tooltip } from '@mui/material'

type MTReturnsActionsCellProps = {
  rowId: string
  onView: (rowId: string) => void
  onRefresh: (rowId: string) => void
  refreshing?: boolean
  viewing?: boolean
  viewDisabled?: boolean
  /** Disable the refresh button independently (e.g. another row is busy). */
  refreshDisabled?: boolean
}

/**
 * Renders the two per-row actions in the Returns grid Actions column:
 * - View: opens the generated return output (layout per Return Mapping, PNW-1724).
 * - Refresh: regenerates the return from current computed data (AC8 replace).
 */
export function MTReturnsActionsCell({
  rowId,
  onView,
  onRefresh,
  refreshing = false,
  viewing = false,
  viewDisabled = false,
  refreshDisabled = false,
}: MTReturnsActionsCellProps) {
  return (
    <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center', justifyContent: 'flex-start' }}>
      <Tooltip title="View">
        <span>
          <IconButton
            size="small"
            aria-label="View return"
            onClick={() => onView(rowId)}
            disabled={viewDisabled || viewing}
            sx={{ color: 'var(--forbrand-primary)' }}
          >
            {viewing ? <CircularProgress size={16} /> : <VisibilityOutlinedIcon fontSize="small" />}
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title="Refresh (regenerate)">
        <span>
          <IconButton
            size="small"
            aria-label="Regenerate return"
            onClick={() => onRefresh(rowId)}
            disabled={refreshing || refreshDisabled}
            sx={{ color: 'var(--forbrand-primary)' }}
          >
            {refreshing ? <CircularProgress size={16} /> : <RefreshIcon fontSize="small" />}
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  )
}

export default MTReturnsActionsCell
